export type RedTypographyDefinition = {
  fontFamily: string;
  fontSize: string;
  fontStyle: 'normal' | 'italic';
  fontWeight: string;
  lineHeight: string;
};

export const RED_TAILWIND_TYPOGRAPHY_DEFINITIONS: Record<string, RedTypographyDefinition> = {
  'red-tw-headline': {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '34px',
  },
  'red-tw-title': {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '21px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '32px',
  },
  'red-tw-subheader': {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '26px',
  },
  'red-tw-body1': {
    fontFamily: 'Lato, sans-serif',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '24px',
  },
  'red-tw-body2': {
    fontFamily: 'Lato, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px',
  },
  'red-tw-assistive': {
    fontFamily: 'Lato, sans-serif',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '16px',
  },
};

export const RED_TAILWIND_TYPOGRAPHY_CLASS_NAMES: readonly string[] = Object.keys(RED_TAILWIND_TYPOGRAPHY_DEFINITIONS);
